import React, { useEffect, useMemo } from 'react';
import './StandardRadioButtonSelector.css';

function normaliseItems(items) {
    return (Array.isArray(items) ? items : []).map((item, index) => {
        if (typeof item === 'string' || typeof item === 'number') {
            return {
                label: String(item),
                value: String(item),
                description: '',
                disabled: false,
                key: `${String(item)}-${index}`,
            };
        }

        const value = item?.value ?? item?.id ?? item?.label ?? '';
        const label = item?.label ?? item?.text ?? item?.name ?? value;

        return {
            label: String(label),
            value: String(value),
            description: item?.description ? String(item.description) : '',
            disabled: Boolean(item?.disabled),
            key: String(item?.id ?? value ?? index),
        };
    }).filter((item) => item.label && item.value);
}

export function StandardRadioButtonSelector({
    title,
    subHeading = '',
    subheading = '',
    items,
    data = '',
    defaultValue = '',
    setData,
    name = '',
    disabled = false,
    onError = false,
    errorText = '',
    onChangeFunction = null,
}) {
    const normalisedItems = useMemo(() => normaliseItems(items), [items]);
    const radioGroupName = name || `standard-radio-${String(title || 'question').replace(/\s+/g, '-').toLowerCase()}`;
    const displaySubHeading = subHeading || subheading;
    const hasSelectedValue = data !== null && data !== undefined && String(data) !== '';
    const selectedValue = hasSelectedValue ? String(data) : String(defaultValue || '');

    useEffect(() => {
        if (hasSelectedValue || !defaultValue || !setData) {
            return;
        }

        const defaultOption = normalisedItems.find((item) => item.value === String(defaultValue) && !item.disabled);
        if (defaultOption) {
            setData(defaultOption.value);
        }
    }, [defaultValue, hasSelectedValue, normalisedItems, setData]);

    function handleValueChange(event) {
        const selectedValue = event.target.value;

        if (setData) {
            setData(selectedValue);
        }

        if (onChangeFunction) {
            onChangeFunction(selectedValue);
        }
    }

    return (
        <div className={onError ? 'srbsFormRow srbsFormRowError' : 'srbsFormRow'}>
            <div className='srbsTitleDiv'>
                <label className='srbsTitleLabel'>{title}</label>
                {displaySubHeading ? <p className='srbsSubHeading'>{displaySubHeading}</p> : null}
            </div>

            <div className='srbsOptionsDiv'>
                {normalisedItems.length === 0 ? (
                    <p className='srbsEmptyText'>No options available</p>
                ) : (
                    normalisedItems.map((item) => (
                        <label
                            className={item.disabled || disabled ? 'srbsOptionLabel srbsOptionLabelDisabled' : 'srbsOptionLabel'}
                            key={item.key}
                        >
                            <input
                                className='srbsRadioInput'
                                type='radio'
                                name={radioGroupName}
                                value={item.value}
                                checked={selectedValue === item.value}
                                onChange={handleValueChange}
                                disabled={disabled || item.disabled}
                            />
                            <span className='srbsCustomRadio' aria-hidden='true'></span>
                            <span className='srbsOptionTextWrap'>
                                <span className='srbsOptionText'>{item.label}</span>
                                {item.description ? <span className='srbsOptionDescription'>{item.description}</span> : null}
                            </span>
                        </label>
                    ))
                )}
            </div>

            {errorText ? <label className='srbsErrorLabel'>{errorText}</label> : null}
        </div>
    );
}
